import { i18n } from '@/plugins/i18n'

export const fieldsWithoutActions = [
    {
        key: 'rid',
        label: i18n.t('attributes.id'),
    },
    {
        key: 'externalId',
        label: i18n.t('conversion.external_id'),
    },
    {
        key: 'storeName',
        label: i18n.t('store.name'),
        policies: {
            conversion: ['view_any_or_group'],
            store: ['join']
        }
    },
    {
        key: 'amount',
        label: `${i18n.t('conversion.amount')}(${i18n.t('rial')})`,
    },
    {
        key: 'commissionAmount',
        label: `${i18n.t('commission._')}(${i18n.t('rial')})`,
    },
    {
        key: 'wage',
        label: `${i18n.t('commission.wage')}(${i18n.t('rial')})`,
        policies: {
            conversion: ['create']
        }
    },
    {
        key: 'statutoryDeductions',
        label: `${i18n.t('conversion.statutory_deductions')}(${i18n.t('rial')})`,
    },
    {
        key: 'link',
        label: i18n.t('link._'),
        policies: {
            store: ['join']
        }
    },
    {
        key: 'user',
        label: i18n.t('publisher.name'),
        policies: {
            conversion: ['create']
        }
    },
    {
        key: 'status',
        label: i18n.t('conversion.status'),
    },
    {
        key: 'createdAt',
        label: i18n.t('attributes.created_at'),
    },
    {
        key: 'checkedOutAt',
        label: i18n.t('conversion.checked_out_at'),
    },
]

const fields = [
    ...fieldsWithoutActions,
    {
        key: 'actions',
        label: i18n.t('actions'),
        policies: {
            conversion: ['create']
        }
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
]

export const productsFields = [
    {
        key: 'pid',
        label: i18n.t('attributes.id'),
        _style: 'width: 10%',
    },
    {
        key: 'name',
        label: i18n.t('conversion.product_name'),
        _style: 'width: 10%',
    },
    {
        key: 'unitPrice',
        label: `${i18n.t('conversion.unit_price')}(${i18n.t('rial')})`
    },
    {
        key: 'quantity',
        label: i18n.t('conversion.quantity')
    },
    {
        key: 'totalPrice',
        label: `${i18n.t('conversion.total_price')}(${i18n.t('rial')})`
    }
]